import React, {Component} from 'react';
import {Button, Modal} from 'antd';
import {urlPath} from './Settings';
import {getAuthHeader} from '../utils/security';

class ConfirmationModal extends Component {
	constructor(props) {
		super(props);
		this.state = {
			value: null,
			visible: this.props.confirmationModalVisible,
			iconLoading: false,
			matspecId: null,
			admaterialid: null,
			approveTrue: null,
			fileUrl: null,
			translations: this.props.translations || {}
		};
		this.onApprove = this.onApprove.bind(this);
	}

	componentWillReceiveProps(nextProps) {
		this.setState({
			admaterialid: nextProps.admaterialid,
			approveTrue: nextProps.approveTrue,
			fileUrl: nextProps.fileUrl,
			matspecId: nextProps.matspecId,
			translations: nextProps.translations,
			visible: nextProps.confirmationModalVisible
		});
	}

	onApprove() {
		this.setState({iconLoading: true});
		console.log("Commiting MaterialSpecification." + this.state.matspecId + "  AdMaterial." + this.state.admaterialid);
		let targetUrl =
			urlPath + '/api/admaterialcommit?approve_correct=' + this.state.approveTrue + '&matspec=' + this.state.matspecId + '&admaterial=' + this.state.admaterialid;
		fetch(targetUrl, {method: 'POST', credentials: 'include', headers: getAuthHeader()})
			.then(response => {
				console.log('Commited admaterial', response.text());
				setTimeout(function() {
					window.location.reload()
				}, 100);
			})
			.catch(e => console.error("Cannot commit", e));
	}

	render() {
        const {translations} = this.state;
		return (
			<Modal
				title={this.props.text}
				visible={this.state.visible}
				cancelText={translations?translations.cancel:'Cancel'}
				onOk={this.props.onApprove}
				footer={[
					<Button key="back" onClick={() => this.setState({visible: false})}>Cancel</Button>,
					<Button id="confirmApprove" key="submit" type="primary" icon="check-circle-o" loading={this.state.iconLoading} onClick={this.onApprove}>
						{this.props.text}
					</Button>,
				]}>
				<p style={{padding: "10px 25px"}}>{this.props.text} ad material?</p>
			</Modal>
		);
	}
}

export default ConfirmationModal;


// WEBPACK FOOTER //
// ./src/components/ConfirmationModal.js